/* eslint max-len: 0 */
const icon = require('vue-svgicon')
icon.register({
  'user': {
    viewBox: '0 0 16 16',
    data: `<g><path d="M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M4.5,14.1L5,12.4C5.2,11.6,6,11,6.9,11h2.2c0.9,0,1.7,0.6,1.9,1.4l0.5,1.6C10.5,14.7,9.3,15,8,15C6.7,15,5.5,14.7,4.5,14.1z M12.4,13.5L12,12.2c-0.4-1.3-1.6-2.2-2.9-2.2H6.9c-1.3,0-2.5,0.9-2.9,2.2l-0.4,1.3C2,12.2,1,10.2,1,8c0-3.9,3.1-7,7-7c3.9,0,7,3.1,7,7C15,10.2,14,12.2,12.4,13.5z"/><path d="M8,3C6.3,3,5,4.3,5,6s1.3,3,3,3s3-1.3,3-3S9.7,3,8,3z M8,8C6.9,8,6,7.1,6,6s0.9-2,2-2c1.1,0,2,0.9,2,2S9.1,8,8,8z"/></g>`
  }
})
